import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  Paper,
  TextField,
  Tooltip,
  Typography,
  IconButton,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Divider,
  SelectChangeEvent,
  Select,
  MenuItem,
} from "@mui/material";
import variables from "../../../assets/styles/variables.module.scss";
import SummaryCard from "../../../Shared-ui/SharedComponents/Cards/SummaryCard";
import AddIcon from "@mui/icons-material/Add";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import CloseIcon from "@mui/icons-material/Close";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import VisibilityIcon from '@mui/icons-material/Visibility';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import RotateLeftOutlinedIcon from "@mui/icons-material/RotateLeftOutlined";
import ReportGmailerrorredOutlinedIcon from "@mui/icons-material/ReportGmailerrorredOutlined";
import FormView from "./formView";


const paginationModel = { page: 0, pageSize: 10 };


// Custom No Rows Component with Image
function CustomNoRowsOverlay() {
    return (
      <Box sx={{ textAlign: 'center', mt: 4 }}>
        <img 
          src="https://via.placeholder.com/150" 
          alt="No Data Available" 
          style={{ marginBottom: 16, width: 150, height: 150 }} 
        />
        <Typography variant="h6" color="textSecondary">
          No data available
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Try adjusting your filters or refresh the page.
        </Typography>
      </Box>
    );
  }

const SourceSharepoint = () => {
  const [databaseType, setDatabaseType] = React.useState("");

  const handleChange = (event: SelectChangeEvent) => {
    setDatabaseType(event.target.value as string);
  };

  const [expanded, setExpanded] = useState<string>(""); // Track expanded panel

  const handleCancel = () => {
    setExpanded(""); // Reset expanded state
  };

  const columns: GridColDef[] = [
    // { field: "id", headerName: "ID", width: 70 },
    { field: "name", headerName: "Name", width: 250 },
    { field: "siteName", headerName: "Site Name", width: 200 },
    { field: "folderPath", headerName: "Folder Path", width: 280 },
    // { field: "clientId", headerName: "Client ID", width: 130 },
    // { field: "tenantId", headerName: "Tenant ID", width: 130 }, 
    // { field: "clientSecret", headerName: "Client Secret", width: 130 },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      renderCell: (params) => {
        const handleEditClick = (event: React.MouseEvent) => {
          event.stopPropagation(); // Prevent row selection
        };
  
        const handleDeleteClick = (event: React.MouseEvent) => {
          event.stopPropagation(); // Prevent row selection
          setOpen(true);
        };
  
        return (
          <Box>
            <IconButton aria-label="view" onClick={() => setExpanded("view")}>
              <VisibilityIcon />
            </IconButton>
            <IconButton aria-label="edit">
              <EditOutlinedIcon />
            </IconButton>
            <IconButton aria-label="delete">
              <DeleteOutlineOutlinedIcon />
            </IconButton>
          </Box>
        );
      },
    },
  ];
  
  const rows:any = [
    {
      id: 1,
      name: "Demo SharePoint Config",
      siteName: "DemoSite",
      folderPath: "/Shared Documents/DemoFolder",
      clientId: "12345678-90ab-cdef-1234-567890abcdef",
      tenantId: "abcdef12-3456-7890-abcd-ef1234567890",
      clientSecret: "dummyClientSecretKey12345!@#$%",
    },
    {
      id: 2,
      name: "Marketing SharePoint Config",
      siteName: "MarketingPortal",
      folderPath: "/Shared Documents/Campaigns",
      clientId: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
      tenantId: "12345678-90ab-cdef-1234-567890abcdef", 
      clientSecret: "dummyMarketingSecretKey67890!@#", 
    },
    {
      id: 3,
      name: "HR SharePoint Config",
      siteName: "HRDocs", 
      folderPath: "/Shared Documents/Policies",
      clientId: "abcdef12-3456-7890-abcd-ef1234567890",
      tenantId: "f1234567-890a-bcde-f123-4567890abcdef",
      clientSecret: "dummyHRSecretKey12345!@#$",
    },
  ];
  

  return (
    <Box
      sx={{
        width: "100%",
        display: "block",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          ml: -2,
          mr: -2,
        }}
      >
        {/* Left Content */}
        <Box
          sx={{
            width: {
              lg: "calc(100% - 300px)",
              md: "calc(100% - 300px)",
              sm: "100%",
            },
            flex: "0 0 auto",
            boxSizing: "border-box",
            minWidth: {
              lg: "calc(100% - 300px)",
              md: "calc(100% - 300px)",
              sm: "100%",
            },
            pl: 2,
            pr: 2,
            maxWidth: "100%",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h6" gutterBottom>
                Sharepoint
            </Typography>
            <Box>
              <Tooltip title="Add Question" placement="top">
                <IconButton
                  color="secondary"
                  aria-label="add icon"
                  sx={{ color: variables.primaryColor }}
                  onClick={() => setExpanded("new")}
                >
                  <AddIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>

          {/* Add Connection Box */}
          {expanded === "new" && (
            <Box
              sx={{
                "&::before": {
                  content: '""',
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  zIndex: 7,
                },
              }}
            >
              <Box
                sx={{
                  width: "500px",
                  display: "flex",
                  flexDirection: "column",
                  gap: 3,
                  pt: "10px",
                  position: "fixed",
                  right: "0",
                  top: "0",
                  height: "100vh",
                  background: variables.whiteColor,
                  padding: "20px 30px",
                  zIndex: 8,
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    height: "100%",
                  }}
                >
                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography variant="h6" gutterBottom>
                        New Sharepoint
                      </Typography>
                      <IconButton aria-label="close" onClick={handleCancel}>
                        <CloseIcon />
                      </IconButton>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 3,
                        mt: 2,
                        pt: "5px",
                        height: "calc(100vh - 160px)",
                        overflow: "auto",
                      }}
                    >
                      <FormControl fullWidth variant="outlined" required>
                        <InputLabel
                          htmlFor="name"
                          shrink
                          sx={{ background: "#fff", px: 0.5 }}
                        >
                          Name
                        </InputLabel>
                        <TextField
                          //size="small"
                          id="name"
                          name="name"
                          placeholder="Enter the name"
                          sx={{ background: "white" }}
                        />
                      </FormControl>
                      

                      <FormControl fullWidth variant="outlined" required>
                        <InputLabel
                          htmlFor="siteName"
                          shrink
                          sx={{ background: "#fff", px: 0.5 }}
                        >
                          Site Name
                        </InputLabel>
                        <TextField
                          // size="small"
                          id="siteName"
                          name="siteName"
                          placeholder="Enter site name"
                          sx={{ background: "white" }}
                        />
                      </FormControl>
                      <FormControl fullWidth variant="outlined" required>
                        <InputLabel
                          htmlFor="folderPath"
                          shrink
                          sx={{ background: "#fff", px: 0.5 }}
                        >
                          Folder Path
                        </InputLabel>
                        <TextField
                          // size="small"
                          id="folderPath"
                          name="folderPath"
                          placeholder="Enter the folder path"
                          sx={{ background: "white" }}
                        />
                      </FormControl>
                      <FormControl fullWidth variant="outlined" required>
                        <InputLabel
                          htmlFor="clientId"
                          shrink
                          sx={{ background: "#fff", px: 0.5 }}
                        >
                          Client ID
                        </InputLabel>
                        <TextField
                          // size="small"
                          id="clientId"
                          name="clientId"
                          placeholder="Enter the client ID"
                          sx={{ background: "white" }}
                        />
                      </FormControl>
                      <FormControl fullWidth variant="outlined" required>
                        <InputLabel
                          htmlFor="tenantId"
                          shrink
                          sx={{ background: "#fff", px: 0.5 }}
                        >
                          Tenant ID
                        </InputLabel>
                        <TextField
                          // size="small"
                          id="tenantId"
                          name="tenantId"
                          placeholder="Enter tenant Id"
                          sx={{ background: "white" }}
                        />
                      </FormControl>
                      <FormControl fullWidth variant="outlined" required>
                        <InputLabel
                          htmlFor="clientSecret"
                          shrink
                          sx={{ background: "#fff", px: 0.5 }}
                        >
                          Client Secret
                        </InputLabel>
                        <TextField
                          // size="small"
                          id="clientSecret"
                          name="clientSecret"
                          placeholder="Enter client secret"
                          sx={{ background: "white" }}
                        />
                      </FormControl>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      gap: 2,
                      justifyContent: "flex-end",
                      position: "absolute",
                      bottom: 0,
                    }}
                  >
                    <Button
                      fullWidth
                      variant="outlined"
                      disableElevation
                      size="large"
                      sx={{
                        textTransform: "capitalize",
                      }}
                      onClick={handleCancel} // Call handleCancel on click
                    >
                      Cancel
                    </Button>
                    <Button
                      fullWidth
                      variant="contained"
                      disableElevation
                      size="large"
                      sx={{
                        textTransform: "capitalize",
                      }}
                    >
                      Save
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Box>
          )}
          {expanded === "view" && (
            <FormView/>
          )}

          <Paper sx={{ height: 400, width: "100%", mt: "20px" }} elevation={0}>
            <DataGrid
              rows={rows}
              columns={columns}
              initialState={{ pagination: { paginationModel } }}
              pageSizeOptions={[10]}
              //checkboxSelection
              // components={{
              //   NoRowsOverlay: CustomNoRowsOverlay, // Correctly reference the custom component
              // }}
              sx={{
                border: 1,
                borderColor: variables.borderColor,
                "& .MuiDataGrid-cell:focus": {
                  outline: "none",
                },
                "& .MuiDataGrid-cell:focus-within": {
                  outline: "none",
                },
              }}
            />
          </Paper>
        </Box>

        {/* Right Summary Card */}
        <Box
          sx={{
            width: { lg: "300px", md: "300px", sm: "100%" },
            minWidth: { lg: "300px", md: "300px", sm: "100%" },
            boxSizing: "border-box",
            flex: "0 0 auto",
            pl: 2,
            pr: 2,
            mt: { lg: "0", md: "0", sm: "30px" },
          }}
        >
          <SummaryCard />
        </Box>
      </Box>
    </Box>
  );
};

export default SourceSharepoint;
function setOpen(arg0: boolean) {
  throw new Error("Function not implemented.");
}
